import Quill from 'quill';
import AnchorBlot from './blots/anchor';

class AnchorModule {
    constructor(quill, options) {
        this.quill = quill;
        this.options = options;
        this.quill.root.addEventListener('click', this.handleClick.bind(this), false);
        this.quill.on('text-change', this.onTextChange.bind(this));
    }

    handleClick(e) {
        if (e.target && e.target.tagName && e.target.tagName.toUpperCase() === 'A' && e.target.classList.contains('ql-anchor')) {
            this.quill.emitter.emit('anchor-clicked', Quill.find(e.target));
        }
    }

    onTextChange(delta, oldDelta, source) {
        if (source === 'user') {
            let anchors = this.quill.container.querySelectorAll('a.ql-anchor');
            for(let i=0; i<anchors.length; i++) {
                if (Quill.find(anchors[i]).prev) {
                    anchors[i].classList.remove('first-child')
                } else {
                    anchors[i].classList.add('first-child')
                }
            }
        }
    }
}

Quill.register('modules/anchor', AnchorModule);

export default AnchorModule;